import React from "react";
import "./Professiogramma.css";
import { Link } from "react-router-dom";
import Search from "../Search";
import axios from "axios";
import ProfessiogrammaPagination from "./ProfessiogrammaPagination";
import { baseURL } from "../Config/Config";
import { ProfContext } from "../context/proffessiogramma_context";

export default function Professiogramma() {
  const [dataprof, setDataprof] = React.useState();
  const [totalData, setTotalData] = React.useState();
  const [category, setCategory] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [current_page, setCurrent_page] = React.useState();
  const [total_pages, setTotal_pages] = React.useState();

  const [profContext] = React.useContext(ProfContext)

  React.useEffect(() => {
    axios
      .get(
        `${baseURL}professiogramma/professiogramma-list/?category=${category}&page=${page}`
      )
      .then((response) => {
        setDataprof(response.data.results);
        setTotalData(response.data.total);
        setCurrent_page(response.data.current_page);
        setTotal_pages(response.data.total_pages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [category, page]);
  const hadleFilter = (id) => {
    setCategory(id)
  }

  if (!dataprof) return (
    <div className="spinnerBlog">
      <div className="spinner">
      </div>
    </div>
  )

  return (
    <div>
      <div className="container video_name">
        <h1 className="daraja_name">Professiogrammalar {' '} {totalData}</h1>
      </div>
      <div className="container">
        <div className="professiogramma">
          <div className="video-top">
            <div className="left">
              <Link to="/" className="bosh">
                Bosh sahifa
              </Link>
              <Link to="/professiogramma" className="left-material">
                Professiogramma
              </Link>
            </div>
            <div className="search-right">
              <Search />
            </div>
          </div>
          <div className="pro-cards">
            <div className="pro-left">
              <h3 className="pro-border-bottom">Kasb va mutaxassisliklar</h3>
              <div className="pro-turi">
                <label htmlFor="all">
                  <span> Barchasi</span>
                  <input
                    type="radio"
                    name="name"
                    id="all"
                    onClick={(e) => hadleFilter("", e)}
                  />
                </label>
                {profContext.map((item) => {
                  return (
                    <div key={item.id}>
                      <label htmlFor={item.id}>
                        <span> {item.title}</span>
                        <input
                          type="radio"
                          name="name"
                          id={item.id}
                          onClick={(e) => hadleFilter(item.id, e)}
                        />
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="pro-right">
              {dataprof.map((item) => {
                return (
                  <Link className="pro-card" id={`${item.id}`} key={item.id} to={`/professiogramma/${item.id}/`}>
                    <div>
                      <span>Mutaxasislik</span><br />
                      <p>
                        {item.code} - {item.title}
                      </p>
                      <div className="pro-img">
                        <img alt="rasm" src={item.photo} />
                      </div>
                    </div>
                  </Link>
                )
              })}
            </div>

          </div>
        </div>
        <ProfessiogrammaPagination
          setPage={setPage}
          current_page={current_page}
          total_pages={total_pages}
        />
      </div>
    </div>
  );
}
